import React, { Component } from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Link } from 'react-router';

import ObservacioSelectorPeriode from './observacioSelectorPeriode';
import ObservacioSelectorDataPeriode from './observacioSelectorDataPeriode';
import obtenirDetallObservacioSelector from '../../selectors/selector_observacio_per_codi';
import EstacioSelector from './estacioSelector';
import { rutaIntroduirObservacions } from '../../routes/routeConstants';

import seguretatWrapper from '../seguretat/seguretatWrapper';
import { esPotCrearObservacio } from '../../commons/callbacksSeguretat';

/**
 * Representa el panel mitjançant el qual es modificara la data de consulta de les observacions a la vista de
 * visualitzacio d'observacions.
 *
 */
class ObservacioData extends Component {

    /**
     * Indica, depenent dels estats, si el botó d'introducció d'observacions
     * ha d'estar habilitat o inhabilitat.
     *
     * @returns {boolean}
     */
    isBotoIntroduccioObservacioHabilitat() {
        const {estats, dataSeleccionada} = this.props;
        return estats && estats.some(dia => dia.data === dataSeleccionada);
    }

    render() {

        const EstacioSelectorAmbSeguretat = seguretatWrapper(EstacioSelector, esPotCrearObservacio);
        const LinkAmbSeguretat = seguretatWrapper(Link, esPotCrearObservacio);

        return (
            <div>
                <div className='observacio-data-element observacio-selector-data-periode'>
                    <ObservacioSelectorDataPeriode />
                </div>
                <div className='observacio-data-element observacio-selector-periode'>
                    <ObservacioSelectorPeriode />
                </div>
                <div className='observacio-data-element observacio-selector-estacio'>
                    <EstacioSelectorAmbSeguretat />
                </div>
                <div className='observacio-boto-introduccio observacio-data-element'>
                    <LinkAmbSeguretat to={rutaIntroduirObservacions}>
                        <Button
                            icon='form'
                            type='primary'
                            disabled={!this.isBotoIntroduccioObservacioHabilitat()}>
                            Observació
                        </Button>
                    </LinkAmbSeguretat>
                </div>
            </div>
        );
    }
}

ObservacioData.propTypes = {
    observacio: PropTypes.object,
    dataSeleccionada: PropTypes.string,
    estats: PropTypes.array
};

const mapStateToProps = (state) => ({
    observacio: obtenirDetallObservacioSelector(state),
    dataSeleccionada: state.observacio.dataSeleccionada,
    estats: state.observacio.estats
});

export default connect(mapStateToProps, null)(ObservacioData);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioData.js